/**
 * Lootable containers (lockers/cabinets/crates) — a prop the player loots with E
 * to move its items into their dungeon-loot inventory. Distinct from a corpse.
 * A container may carry a lock (`lockId` → `MapData.locks`); while locked, E
 * reports "Locked" until the lock is destroyed or opened with a matching key.
 *
 * The container sits on a blocking prop tile (so you can't stand on it and it
 * stops bullets); this record holds its runtime loot state. Headless.
 */

import type { Item } from './inventory';

let nextContainerId = 1;

export interface Container {
  id: number;
  x: number;
  y: number;
  glyph: string;
  items: Item[];
  /** Guarding lock id (→ MapData.locks), or null if unlocked/no lock. */
  lockId: number | null;
  looted: boolean;
}

export interface CreateContainerArgs {
  x: number;
  y: number;
  glyph?: string;
  items?: Item[];
  lockId?: number | null;
}

export function createContainer(args: CreateContainerArgs): Container {
  return {
    id: nextContainerId++,
    x: args.x,
    y: args.y,
    glyph: args.glyph ?? '⌂',
    items: args.items ?? [],
    lockId: args.lockId ?? null,
    looted: false,
  };
}
